type MemoizeState<T> = { memoized: undefined; called: false } | { memoized: T; called: true }

export function memoize<VALUE>(fun: () => VALUE): () => VALUE {
  let state: MemoizeState<VALUE> = {
    memoized: undefined,
    called: false,
  }

  return () => {
    if (!state.called) {
      state = { memoized: fun(), called: true }
    }
    return state.memoized
  }
}
